<div class="scc-root">
  <div #chartHost class="scc-host"></div>
  <div #tooltip class="scc-tooltip"></div>
  <div *ngIf="noData" class="scc-empty">
    <p>No data available to plot this control chart.</p>
  </div>
</div>
